import React from "react";
import LandingLayout from '@/js/layouts/landing/LandingLayout';
import DashboardLayout from '@/js/layouts/dashboard/DashboardLayout';
import userStore from '@/js/modules/users/store/v2/UserStore';
import { useQuery } from "@tanstack/react-query";

export default function CommonLayout() {
	const { data: user, isLoading, isError } = useQuery({
		queryKey: ['me'],
		queryFn: () => userStore.fetchMe(),
		staleTime: 1000 * 60 * 5,
		refetchOnWindowFocus: false,
	});

	if (isLoading) return null;
	if (isError || !user) return <LandingLayout hideFooter />;
	return <DashboardLayout />;
}
